import React from 'react';
import classnames from 'classnames';
import ArrowDown from '../../Icons/ArrowDown';
import NativeDropdown from '../NativeDropdown';
import { NullableDropdownItem } from '../types';
import noop from 'lodash/noop';
import s from './MobileNativeDropdown.scss';

export interface Props {
  items: NullableDropdownItem[];
  title?: string;
  className?: string;
  titleClassName?: string;
  arrowClassName?: string;
  isLegacyFormInput?: boolean;
  onSelect?: (value: any, event: any) => void;
}

/**
 * A dropdown that uses the native select and meant for mobile UIs
 */
export const MobileNativeDropdown: React.FC<Props> = ({
  items,
  title,
  className,
  titleClassName,
  arrowClassName,
  isLegacyFormInput,
  onSelect = noop,
}) => {
  return (
    <div
      className={classnames(
        s['native-dropdown-wrap'],
        s['updated-inputs'],
        isLegacyFormInput && s['legacy-form-input'],
        className
      )}
    >
      <div className={s['native-dropdown-title-wrap']} aria-hidden="true">
        <div className={classnames(s['native-dropdown-title'], titleClassName)}>
          {title}
        </div>
        <ArrowDown
          className={classnames(s['native-dropdown-arrow'], arrowClassName)}
        />
      </div>
      <div className={s['native-dropdown-hidden']}>
        <NativeDropdown onSelect={onSelect} items={items} />
      </div>
    </div>
  );
};
MobileNativeDropdown.displayName = 'MobileNativeDropdown';

export default MobileNativeDropdown;
